module.exports = __webpack_public_path__ + "static/media/tablet-dark.b7679936.svg";